// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)
// ЕДИНЫЙ ИСТОЧНИК ЗОН ЗАПАСА: круги вида «Статуси й зони» (cellViews/statusZones.js, спутник zone_val) и полосы зон нижней панели «Покриття, міс»
// графика формы ячейки (cellChart.js) берут порядок, цвета и названия отсюда. Ключ зоны = категория запаса движка (processing_distr.get_grade):
//   oos      — stock < 0                         — Negative stock (OOS)  — красная      (график: oosDOS)
//   min      — DOS < min                         — Critical              — рыжая        (график: zone_min, полоса до min)
//   opt      — min ≤ DOS < opt                   — Replenishment zone    — жёлтая       (график: zone_replenishment, полоса min…opt)
//   ok       — opt ≤ DOS ≤ max                   — Optimal               — белая        (график: zone_opt, полоса opt…max, без заливки)
//   max      — max < DOS ≤ excess                — Maximum               — зелёная      (график: zone_max, полоса max…excess / до потолка оси)
//   excess   — DOS > excess (порог правила)      — Over-norm             — тёмно-зелёная (график: zone_excess, от порога до потолка оси)
//   no_sales — запас без расхода                 — Without sales         — серая        (на графике полосы нет)
// До p207 у круга была своя шкала со сдвигом на одну зону: opt («Оптимальний», салатовый) — это полоса min…opt графика (жёлтая «Зона поповнення»),
// ok («Нормативний», зелёный) — белая оптимальная полоса, max (синий) — зелёная, excess (тёмно-синий) — сверхнорматив; min («Мінімальний») — критическая.
// Выключатель fe.ux.stockZonesChartPalette (по умолчанию ВКЛ): ВЫКЛ — прежние цвета / названия круга и прежние полосы графика.
import { feFlag_read } from '@/utils/signalModel'

export const STOCK_ZONES_FLAG = 'fe.ux.stockZonesChartPalette'
export const STOCK_ZONE_ORDER = ['oos', 'min', 'opt', 'ok', 'max', 'excess', 'no_sales']
export const STOCK_ZONE_CTX = 'stock zone'   // контекст словаря: «Critical|stock zone» (у голого «Critical» перевод «Критично» — для других мест)
// color — круг ячейки и свотч легенды графика; fill — полоса графика (тот же цвет с альфой: вертикальные полосы drawAlarmZone видны сквозь неё);
// edge — обводка светлого цвета (белая зона видна на белом фоне)
export const STOCK_ZONES = {
    oos: { title: 'Negative stock (OOS)', color: '#ef5350', fill: '#ef5350bb' },
    min: { title: 'Critical', color: '#ffa94d', fill: '#ffa94dbb' },
    opt: { title: 'Replenishment zone', color: '#ffe066', fill: '#ffe066bb' },
    ok: { title: 'Optimal', color: '#ffffff', fill: 'none', edge: '#9e9e9e' },
    max: { title: 'Maximum', color: '#81c784', fill: '#81c784bb' },
    excess: { title: 'Over-norm', color: '#2e7d32', fill: '#2e7d32bb' },
    no_sales: { title: 'Without sales', color: '#9e9e9e', fill: '#9e9e9ebb' },
}
// серия зоны графика формы ячейки → ключ зоны
export const CHART_SERIES_ZONE = { oosDOS: 'oos', zone_min: 'min', zone_replenishment: 'opt', zone_opt: 'ok', zone_max: 'max', zone_excess: 'excess' }

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
// 'stock-ok' / 'zone-max' / 'grade-opt' / 'no-sales' / 'dead' → ключ шкалы
export function stockZone_key(z) {
    const k = str(z).replace(/^(stock|zone|grade)-/i, '').toLowerCase().replace(/-/g, '_')
    return k === 'dead' ? 'no_sales' : k
}
export function stockZone_isZone(z) { return Object.prototype.hasOwnProperty.call(STOCK_ZONES, stockZone_key(z)) }
export function stockZone_color(z) { const e = STOCK_ZONES[stockZone_key(z)]; return e ? e.color : '' }
export function stockZone_fill(z) { const e = STOCK_ZONES[stockZone_key(z)]; return e ? e.fill : '' }
export function stockZone_rank(z) { const i = STOCK_ZONE_ORDER.indexOf(stockZone_key(z)); return i < 0 ? STOCK_ZONE_ORDER.length : i }
// название зоны на языке интерфейса: t(text, params, ctx) словаря (ключ «text|stock zone»); t без контекста (тесты) — английский текст
export function stockZone_title(z, t) {
    const e = STOCK_ZONES[stockZone_key(z)]
    if (!e) return ''
    return typeof t === 'function' ? t(e.title, undefined, STOCK_ZONE_CTX) : e.title
}
// свотч легенды: светлая зона — заливка с серой рамкой 1 px (как прежний белый свотч графика), иначе цвет
export function stockZone_swatch(z) {
    const e = STOCK_ZONES[stockZone_key(z)]
    if (!e) return ''
    return e.edge ? `linear-gradient(${e.color}, ${e.color}) center / calc(100% - 2px) calc(100% - 2px) no-repeat, ${e.edge}` : e.color
}

// выключатель: принудительно (тесты / консоль) → URL ?fe.ux.stockZonesChartPalette=false → feSettings (override) → feSettings.db; перечитывается не чаще раза в 2 с
let _forced = null, _cached = true, _at = 0
export function stockZones_force(v) { _forced = v === null || v === undefined ? null : !!v; _at = 0 }
export function stockZones_on() {
    if (_forced !== null) return _forced
    const now = Date.now()
    if (now - _at > 2000) {
        let v
        try {
            if (typeof location !== 'undefined') {
                const qs = new URLSearchParams(String(location.search || '') + '&' + String(location.hash || '').split('?').slice(1).join('&'))
                if (qs.has(STOCK_ZONES_FLAG)) v = qs.get(STOCK_ZONES_FLAG)
            }
        } catch (e) { v = undefined }
        if (v === undefined) v = feFlag_read(STOCK_ZONES_FLAG, true)
        _cached = !(v === false || v === 'false' || v === 0 || v === '0')
        _at = now
    }
    return _cached
}
